import { NETWORK_CONFIG, allowedTokens } from '../configs/networkConfig'

//  Get network logo
export const getNetworkLogo = (network) => {
  return NETWORK_CONFIG[network]?.logo || null
}

//  Get network label
export const getNetworkLabel = (network) => {
  return NETWORK_CONFIG[network]?.label || network
}

//  Get network from token
export const getNetworkByToken = (token) => {
  return Object.entries(NETWORK_CONFIG).find(([, net]) =>
    Object.keys(net.tokens).includes(token)
  )?.[0]
}

//  Get token logo
export const getTokenLogo = (token) => {
  const network = getNetworkByToken(token)
  return network ? NETWORK_CONFIG[network]?.tokens[token]?.logo || null : null
}

//  Get token config
export const getTokenConfig = (token) => {
  const network = getNetworkByToken(token)
  if (!network) return null

  return {
    token,
    network,
    ...NETWORK_CONFIG[network].tokens[token],
  }
}

//  Get explorer URL
export const getExplorerUrl = (network, type, value) => {
  return NETWORK_CONFIG[network]?.explorer?.(type, value) || '#'
}

//  Dropdown data (Step3)
export const getNetworkOptions = () => {
  return Object.entries(NETWORK_CONFIG).map(([networkKey, network]) => ({
    value: networkKey,
    label: network.label,
    tokens: Object.keys(network.tokens).map((token) => ({
      value: token,
      label: token,
    })),
  }))
}

//  Get all allowed tokens (ordered)
export const getAllTokens = () => {
  return allowedTokens.filter((token) => getNetworkByToken(token))
}

//  Get all allowed tokens with config (ordered)
export const getAllTokensWithConfig = () => {
  return allowedTokens
    .map((token) => {
      const config = getTokenConfig(token)
      return config ? config : null
    })
    .filter(Boolean)
}

//  Get wallet address by network
export const getWallet = (wallets, network) => {
  if (wallets?.length > 0) {
    return wallets.find((wallet) => wallet.blockchain === network)?.address
  }
}
